<template>
  <div class="dialog" v-if="CompanyInformation">
    <span class="cls"></span>
    <div class="paper" >
      <h2 class="title" >"{{ CompanyInformation[0]?.name }}"<br><br>그룹에서 초대장이 왔습니다. <br>참가 하시겠습니까? </h2>
      <div class="btns">
        <button @click="refuse">거절</button>
        <button @click="accept" class="positive">수락</button>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref, onMounted } from "vue";

export default {
  name: "dialog_groupInvDialog",
  props: {
    fromGroup: {
      type: [String, Object],
      required: true
    }
  },
  emits: ["close"],
  setup(props, { emit }) {

    const sql_query = inject("sql_query");
    const getUserProfileInfo = inject("getUserProfileInfo");
    
    const userProfile = ref(null);
    const CompanyInformation = ref(null);

    onMounted(async () => {
      userProfile.value = await getUserProfileInfo(props.fromGroup[0].mb_id);
      CompanyInformation.value = await fetchCompanyInfo(props.fromGroup[0].main_group_idx);
    });

    async function fetchCompanyInfo(idx) {
      console.log(idx);
      const sql = `SELECT * FROM group_node WHERE idx = '${idx}' LIMIT 1`;
      const res = await sql_query(sql);
      return res;
    }

    function closeDialog() {
      emit("close");
    }

    function refuse() {
      sql_query(`DELETE FROM group_member WHERE mb_id = '${props.fromGroup[0].mb_id}' and main_group_idx = '${props.fromGroup[0].main_group_idx}'`);
      emit("close");
    }

    function accept() {
      sql_query(`UPDATE group_member SET status = 'join' WHERE mb_id = '${props.fromGroup[0].mb_id}' and main_group_idx = '${props.fromGroup[0].main_group_idx}'`);
      emit("close");
    }

    return {
      closeDialog,
      userProfile,
      CompanyInformation,
      refuse,
      accept
    };
  }
};
</script>

<style scoped>
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.dialog > .cls {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width: 600px;
  background: var(--color-background-light);
  border: 1px solid var(--color-background);
  border-radius: 16px;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
}
.dialog > .paper::-webkit-scrollbar {
  width: 0px;
}

.dialog > .paper .btns {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.dialog > .paper .btns button {
  width:100%;
  flex:1;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size:var(--font-size-md);
  background: var(--color-primary);
  color: var(--color-text-primary);
  font-weight: bold;
  cursor: pointer;
}

.dialog > .paper > h2.title {
  font-size: var(--font-size-lg);
  font-weight: bold;
  color: var(--color-text-primary);
  margin: 0;
  text-align: center;
}

.dialog > .paper .btns button.positive {
  background: var(--color-brand);
  color:#000;
}

</style>